import React from 'react'
import parser from 'html-react-parser'
import { Link } from 'gatsby'
import {
    container,
    bannerWrapper,
    gradientOverlay,
    homeHeroVideo,
    headingLevel1,
    subtitle,
    whiteBtn,
    btn,
    heroRtSec,
    homeHeroContainer
} from './Page_Acfbuilder_Wrapper_HeroHome.module.css'

export default function Page_Acfbuilder_Wrapper_HeroHome({ data }) {
    const { heroHomeButtonText, heroHomeButtonLink, heroHomeImage, heroHomeSubtitle, heroHomeTitle, heroHomeVideo, heroHomeButtonExternalLink } = data
    return (
        <div
            className={`banner-wrapper gradient-overlay ${bannerWrapper} ${gradientOverlay}`}
            style={{ background: `url(${heroHomeImage?.localFile?.publicURL}) left bottom no-repeat` }}
        >
            <video className={`home-hero-video ${homeHeroVideo}`} muted loop autoPlay='play'>
                <source src={heroHomeVideo?.localFile?.publicURL} type='video/webm' />
            </video>
            <div className={`container  home-hero-container ${container} ${homeHeroContainer}`}>
                <div className='row'>
                    <div className='col-md-10'>
                        {heroHomeTitle && <h1 className={`heading-level-1 ${headingLevel1}`}>{parser(heroHomeTitle)}</h1>}
                        {heroHomeSubtitle && <p className={`${subtitle}`}>{parser(heroHomeSubtitle)}</p>}

                        {heroHomeButtonExternalLink ? (
                            <a href={heroHomeButtonExternalLink} className={`btn white-btn ${btn} ${whiteBtn}`}>
                                {heroHomeButtonText}
                            </a>
                        ) : heroHomeButtonLink ? (
                            <Link to={heroHomeButtonLink.uri} className={`btn white-btn ${btn} ${whiteBtn}`}>
                                {heroHomeButtonText}
                            </Link>
                        ) : null}
                    </div>
                    <div className={`col-md-2 hero-rt-sec ${heroRtSec}`}> </div>
                </div>
            </div>
        </div>
    )
}
